import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARFISH_STARTER_ONBOARDING_TOGGLE = createFcmConfig('starfish_starter_onboarding_toggle', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
